__turbopack_context__.v({
  "bottomBlend": "ForClubsHeroImageLayers-module-scss-module__WvUHXG__bottomBlend",
  "darken": "ForClubsHeroImageLayers-module-scss-module__WvUHXG__darken",
  "grainNoise": "ForClubsHeroImageLayers-module-scss-module__WvUHXG__grainNoise",
});
